import { Component, OnInit, input, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentService, ApKeyOverridePipe, ApContentPipe } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApFormControlPipe } from '@ap/cdk';
import { ApDateInputComponent } from '@ap/input/date';

import { ApPersonalDetailsLimitedComponent } from '../personal-details-limited/personal-details-limited.component';

import vkgLimitedContent from './personal-details-vkg-limited.content.json';
import { PersonalDetailsVkgLimitedForm } from './personal-details-vkg-limited.model';

/** This component can be used by customers to enter details about birthinformation */
@Component({
    selector: 'ap-personal-details-vkg-limited',
    templateUrl: './personal-details-vkg-limited.component.html',
    styleUrls: ['../personal-details.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ApPersonalDetailsLimitedComponent,
        ApDateInputComponent,
        ApFormControlPipe,
        ApContentPipe,
        ApKeyOverridePipe
    ]
})
export class ApPersonalDetailsVkgLimitedComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /** The form group to bind to see {@link ApPersonalDetailsVkgLimitedService} */
    public readonly vkgLimitedForm = input<FormGroup<PersonalDetailsVkgLimitedForm>>();

    /**
     * Keymap for content overrides
     */
    public readonly contentKeyMap = input<{
        [contentKey: string]: string;
    }>();

    /**
     * Maximum date to be selected
     */
    public readonly maxDate = input<Date>();

    /**
     * Minimum date to be selected
     */
    public readonly minDate = input<Date>();

    protected errorMessages: ErrorMessages;

    protected get limitedForm(): FormGroup {
        return this.vkgLimitedForm() as FormGroup;
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(vkgLimitedContent);
        this.setErrorMessages();
    }

    protected setErrorMessages(): void {
        this.errorMessages = {
            required: this.contentService.get(
                new ApKeyOverridePipe().transform('vkg.limited.dateOfBirth.error.required', this.contentKeyMap())
            ),
            incorrect: this.contentService.get(
                new ApKeyOverridePipe().transform('vkg.limited.dateOfBirth.error.incorrect', this.contentKeyMap())
            )
        };
    }
}
